import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext({});

export const CartProvider = ({ children }) => {
    const [cartItems, setCartItems] = useState(() => {
        try {
            const savedCart = localStorage.getItem('bloomstore_cart');
            return savedCart ? JSON.parse(savedCart) : [];
        } catch (e) {
            console.error('Error parsing cart from localStorage', e);
            return [];
        }
    });

    useEffect(() => {
        localStorage.setItem('bloomstore_cart', JSON.stringify(cartItems));
    }, [cartItems]);

    const addToCart = (product, quantity = 1) => {
        setCartItems(prevItems => {
            const existingIndex = prevItems.findIndex(item => item.id === product.id);
            if (existingIndex > -1) {
                const newItems = [...prevItems];
                newItems[existingIndex].quantity += quantity;
                return newItems;
            } else {
                // Determine image URL
                let imageUrl = '/images/placeholder.webp';
                if (product.images && product.images.length > 0) {
                    imageUrl = product.images[0].url || product.images[0];
                } else if (product.imageUrl) {
                    imageUrl = product.imageUrl;
                }

                return [...prevItems, {
                    id: product.id,
                    name: product.name,
                    price: product.price,
                    slug: product.slug,
                    image: imageUrl,
                    quantity: quantity
                }];
            }
        });
    };

    const removeFromCart = (productId) => {
        setCartItems(prevItems => prevItems.filter(item => item.id !== productId));
    };

    const updateQuantity = (productId, quantity) => {
        if (quantity <= 0) {
            removeFromCart(productId);
            return;
        }
        setCartItems(prevItems =>
            prevItems.map(item =>
                item.id === productId ? { ...item, quantity } : item
            )
        );
    };

    const clearCart = () => {
        setCartItems([]);
    };

    const cartCount = cartItems.reduce((total, item) => total + item.quantity, 0);
    const cartTotal = cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);

    return (
        <CartContext.Provider value={{
            cartItems,
            addToCart,
            removeFromCart,
            updateQuantity,
            clearCart,
            cartCount,
            cartTotal
        }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => useContext(CartContext);

export default CartContext;
